"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMaxDaresForBestPlatform = exports.calculateMaxDaresByPlatform = void 0;
const getBreakpoint_1 = __importDefault(require("root/src/shared/util/getBreakpoint"));
const platforms_1 = require("root/src/shared/@types/platforms");
const remeda_1 = require("remeda");
const getMaxDaresMap = {
    [platforms_1.DarePlatform.Twitch]: ({ campaign, averageCcv, }) => (0, getBreakpoint_1.default)({
        count: averageCcv,
        countedProp: 'ccv',
        returnedProp: 'maxDares',
        breakpoints: campaign.ccvBreakpoints,
    }),
    [platforms_1.DarePlatform.YouTube]: ({ campaign, followerCount, }) => (0, getBreakpoint_1.default)({
        count: followerCount,
        countedProp: 'followerCount',
        returnedProp: 'maxDares',
        breakpoints: campaign.followersBreakpoints
            .filter(breakpoint => breakpoint.platform === platforms_1.DarePlatform.YouTube),
    }),
    [platforms_1.DarePlatform.TikTok]: ({ campaign, followerCount, }) => (0, getBreakpoint_1.default)({
        count: followerCount,
        countedProp: 'followerCount',
        returnedProp: 'maxDares',
        breakpoints: campaign.followersBreakpoints
            .filter(breakpoint => breakpoint.platform === platforms_1.DarePlatform.TikTok),
    }),
};
function calculateMaxDaresByPlatform({ followerCount, averageCcv, campaign, platform, }) {
    var _a;
    if (!platform) {
        return 0;
    }
    return (_a = getMaxDaresMap[platform]({ followerCount, averageCcv, campaign })) !== null && _a !== void 0 ? _a : 0;
}
exports.calculateMaxDaresByPlatform = calculateMaxDaresByPlatform;
function calculateMaxDaresForBestPlatform({ followerCount, averageCcv, campaign, connectedPlatforms }) {
    var _a;
    if (connectedPlatforms.length === 0) {
        return null;
    }
    const maxDaresByProviders = connectedPlatforms.map(provider => ({
        maxDares: getMaxDaresMap[provider]({ followerCount, averageCcv, campaign }),
        platform: provider,
    }));
    if (!maxDaresByProviders.length) {
        return null;
    }
    return (_a = (0, remeda_1.maxBy)(maxDaresByProviders, x => x.maxDares)) !== null && _a !== void 0 ? _a : null;
}
exports.calculateMaxDaresForBestPlatform = calculateMaxDaresForBestPlatform;
